import { render, staticRenderFns } from "./CamposConfigFormulario.vue?vue&type=template&id=5d2d5fd8&"
import script from "./CamposConfigFormulario.vue?vue&type=script&lang=js&"
export * from "./CamposConfigFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports